import React from "react";
import Modal from "@amzn/awsui-components-react-v3/polaris/modal";
import Button from "@amzn/awsui-components-react-v3/polaris/button";
import { Box, SpaceBetween } from "@amzn/awsui-components-react-v3";

interface DefaultWizardCancelModalProps {
  visible: boolean;
  onDismiss: (isCanceled: boolean) => void;
}

const DefaultWizardCancelModal: React.FC<DefaultWizardCancelModalProps> = ({
  visible,
  onDismiss,
}): JSX.Element => {
  return (
    <Modal
      header="Exit workflow"
      visible={visible}
      closeAriaLabel="Close"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button
              variant="link"
              formAction="none"
              onClick={() => onDismiss(false)}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              formAction="none"
              onClick={() => onDismiss(true)}
            >
              Exit
            </Button>
          </SpaceBetween>
        </Box>
      }
      onDismiss={() => onDismiss(false)}
    >
      Are you sure you want to exit the workflow? The changes that you made
      won't be saved.
    </Modal>
  );
};

export default DefaultWizardCancelModal;
